module.exports = __webpack_public_path__ + "static/media/JSNLC3.41cb6c96.png";